import React from 'react';

function ConflictOfInterest() {
  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center fw-bold">Conflict of Interest Disclosure</h2>
      <p>All authors must disclose any potential conflicts of interest related to their submission.</p>
      <div className="alert alert-info">Download the form: <a href="#">Conflict_of_Interest_Disclosure.pdf</a> (coming soon)</div>
      <h4 className="mt-4">Instructions</h4>
      <ul>
        <li>Complete the form for each author.</li>
        <li>Upload the completed form with your submission or email it to <a href="mailto:drsyedrizwanabbas@gmail.com">drsyedrizwanabbas@gmail.com</a>.</li>
      </ul>
    </div>
  );
}

export default ConflictOfInterest; 